import React from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Link,
  NavLink,
  Redirect,
  Switch
} from 'react-router-dom'
import AppBar from 'material-ui-next/AppBar';
import Toolbar from 'material-ui-next/Toolbar';
import IconButton from 'material-ui-next/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import Hidden from 'material-ui-next/Hidden';
import Typography from 'material-ui-next/Typography';
import Divider from 'material-ui-next/Divider';
import Drawer from 'material-ui-next/Drawer';
import {
  ListItemIcon,
  ListItemText
} from 'material-ui-next/List';
import {
  withStyles
} from 'material-ui-next/styles';
import {
  MenuList,
  MenuItem
} from 'material-ui-next/Menu';
import Collapse from 'material-ui-next/transitions/Collapse';
import {
  check_roles,
  ADMIN
} from './utils/roles/role_checker.js';

import AuthButton from './widgets/auth_button.react.js';
import Login from './login.react.js';
import Dashboard from './views/dashboard/main.react.js';
import ClientAll from './views/clients/all.react.js';
import ClientNew from './views/clients/new.react.js';
import DeviceAll from './views/devices/all.react.js';
import DeviceNew from './views/devices/new.react.js';
import AdminUserAll from './views/admin/users.react.js';
import AdminUserCreate from './views/admin/new_user.react.js';
import AdminDistAll from './views/admin/dist_packages.react.js';
import AdminDistNew from './views/admin/new_dist.react.js';
import SettingAccount from './views/settings/account.react.js';
import SettingSecurity from './views/settings/security.react.js';
import AuthRequired from './router/auth_required.react.js';

import logo from './assets/svg/logo.svg';
import DashboardIcon from './assets/icons/dashboardIcon.react.js';
import EmployeeIcon from './assets/icons/employeeIcon.react.js';
import DeviceIcon from './assets/icons/deviceIcon.react.js';
import ListIcon from './assets/icons/listIcon.react.js';
import AddIcon from './assets/icons/addIcon.react.js';
import OnlineIcon from './assets/icons/onlineIcon.react.js'
import DistIcon from './assets/icons/distIcon.react.js'
import NewDistIcon from './assets/icons/newDistIcon.react.js';

const drawerWidth = 260
const colorMain = '#3ED5AD'
const colorNavBackground = '#2C2C3F'
const colorFocusHighlight = '#EBEBEB'
const colorSubitemFocusHighlight = '#646475'
const colorDivider = '#979797'

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'auto',
    position: 'relative',
    display: 'flex',
    width: '100%',
  },
  appBar: {
    position: 'fixed',
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    backgroundColor: colorMain,
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  toolbar: theme.mixins.toolbar,
  logo: {
    marginLeft: '8%',
    marginTop: '2%',
  },
  drawerPaper: {
    width: drawerWidth,
    borderRightStyle: 'none',
    backgroundColor: colorNavBackground,
    [theme.breakpoints.up('md')]: {
      position: 'fixed',
    },
  },
  drawerDocked: {
    height: '100%',
    backgroundColor: colorNavBackground
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      marginLeft: drawerWidth,
    },
  },
  title: {
    flex: 1
  },
  navMenu: {
    paddingTop: '0',
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  menuItem: {
    backgroundColor: colorNavBackground,
    '&:focus': {
      '& $primary, & $icon': {
        color: colorMain,
        textDecoration: 'none'
      },
    }
  },
  primary: {
    color: theme.palette.common.white,
    fontWeight: 'bold'
  },
  menuTextLink: {
    textDecoration: 'none',
  },
  menuTextLinkActive: {
    '& $menuItem': {
      backgroundColor: colorFocusHighlight,
      '& $primary, & $icon': {
        color: colorMain,
        textDecoration: 'none',
        fill: colorMain
      },
    },
    '& $nested': {
      backgroundColor: colorSubitemFocusHighlight,
      borderRightColor: '#3ED5AD',
      borderRightStyle: 'solid',
      borderRightWidth: 5,
      '& $primary, & $icon': {
        color: colorMain,
        textDecoration: 'none',
      },
    }
  },
  icon: {
    fill: theme.palette.common.white
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  divider: {
    backgroundColor: colorDivider
  },
});

class App extends React.Component {
  state = {
    mobileOpen: false,
  };

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen
    });
  };

  render() {
    const {
      classes,
      theme
    } = this.props;

    var admin_menu = null;
    var admin_submenu = null;
    var admin_content = (
      <Route path="/admin" >
        <Redirect from="/admin" to="/" />
      </Route>
    );
    var admin_divider = null;
    if (check_roles([ADMIN])) {
      admin_menu = (
        <NavLink to="/admin" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
            <MenuItem className={classes.menuItem}>
              <ListItemIcon>
                <EmployeeIcon className={classes.icon}/>
              </ListItemIcon>
              <ListItemText
                inset
                primary="ADMIN TOOLS"
                classes={{primary: classes.primary}} />
            </MenuItem>
        </NavLink>
      )
      admin_submenu = (
        <Collapse
          in={true}
          timeout = "auto"
          unmountOnExit
        >
          <MenuList component="div" disablePadding>
            <NavLink to="/admin/user/all" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
              <MenuItem button className={[classes.menuItem, classes.nested]}>
                <ListItemIcon>
                  <ListIcon className={classes.icon}/>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="User Management"
                  classes={{primary: classes.primary}} />
              </MenuItem>
            </NavLink>
            <NavLink to="/admin/user/add" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
              <MenuItem button className={[classes.menuItem, classes.nested]}>
                <ListItemIcon>
                  <AddIcon className={classes.icon}/>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="Create User"
                  classes={{primary: classes.primary}} />
              </MenuItem>
            </NavLink>
            <NavLink to="/admin/dist/all" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
              <MenuItem button className={[classes.menuItem, classes.nested]}>
                <ListItemIcon>
                  <DistIcon className={classes.icon}/>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="Dist Packages"
                  classes={{primary: classes.primary}} />
              </MenuItem>
            </NavLink>
            <NavLink to="/admin/dist/new" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
              <MenuItem button className={[classes.menuItem, classes.nested]}>
                <ListItemIcon>
                  <NewDistIcon className={classes.icon}/>
                </ListItemIcon>
                <ListItemText
                  inset
                  primary="Create Package"
                  classes={{primary: classes.primary}} />
              </MenuItem>
            </NavLink>
          </MenuList>
        </Collapse>
      )
      admin_content = (
        <Route path="/admin" >
          <Switch>
            <AuthRequired
              path="/admin/user/all"
              deleted={false}
              component={AdminUserAll}
            />
            <AuthRequired
              path="/admin/user/add"
              component={AdminUserCreate}
            />
            <AuthRequired path="/admin/dist/all" component={AdminDistAll} />
            <AuthRequired path="/admin/dist/new" component={AdminDistNew} />
            <Redirect from="/admin" to="/admin/user/all" />
          </Switch>
        </Route>
      )
      admin_divider = (
          <Divider className={classes.divider}/>
      )
    }

    const drawer = (
      <div>
        <div className={classes.toolbar} styleName="nav-bar-logo-holder">
          <Link to="/"><img className={classes.logo} alt="go to main page" src={logo} width="80%"/></Link>
        </div>
        <MenuList
          component="nav"
          className={classes.navMenu}
        >
          <NavLink to="/dashboard" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
            <MenuItem className={classes.menuItem}>
              <ListItemIcon>
                <DashboardIcon className={classes.icon}/>
              </ListItemIcon>
              <ListItemText inset primary="DASHBOARD" classes={{primary: classes.primary}} />
            </MenuItem>
          </NavLink>
          {admin_divider}
          {admin_menu}
          {admin_submenu}
          <Divider className={classes.divider}/>
          <NavLink to="/devices" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
            <MenuItem className={classes.menuItem}>
              <ListItemIcon>
                <DeviceIcon className={classes.icon}/>
              </ListItemIcon>
              <ListItemText
                inset
                primary="DEVICES"
                classes={{primary: classes.primary}} />
            </MenuItem>
          </NavLink>
          <Collapse in={true} timeout="auto" unmountOnExit>
            <MenuList component="div" disablePadding>
              <NavLink to="/devices/online" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
                <MenuItem button className={[classes.menuItem, classes.nested]}>
                  <ListItemIcon>
                    <OnlineIcon className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText inset primary="Online" classes={{primary: classes.primary}} />
                </MenuItem>
              </NavLink>

              <NavLink to="/devices/all" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
                <MenuItem button className={[classes.menuItem, classes.nested]}>
                  <ListItemIcon>
                    <ListIcon className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText inset primary="All Devices" classes={{primary: classes.primary}} />
                </MenuItem>
              </NavLink>

              <NavLink to="/devices/new" className={classes.menuTextLink} activeClassName={classes.menuTextLinkActive}>
                <MenuItem button className={[classes.menuItem, classes.nested]}>
                  <ListItemIcon>
                    <AddIcon className={classes.icon}/>
                  </ListItemIcon>
                  <ListItemText inset primary="Add Device" classes={{primary: classes.primary}} />
                </MenuItem>
              </NavLink>
            </MenuList>
          </Collapse>
          <Divider className={classes.divider}/>
        </MenuList>
      </div>
    );


    return (
      <Router>
        <div className={classes.root}>
          <AppBar position="static" className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={this.handleDrawerToggle}
                className={[classes.navIconHide, classes.menuButton]}
              >
                <MenuIcon />
              </IconButton>
              <Typography className={classes.title} variant="title" color="inherit" noWrap>
                Zeno IoT
              </Typography>
              <AuthButton />
            </Toolbar>
          </AppBar>
          <Hidden mdUp>
            <Drawer
              variant="temporary"
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden smDown implementation="css">
            <Drawer
              variant="permanent"
              open
              classes={{
                paper: classes.drawerPaper,
                docked: classes.drawerDocked,
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <main className={classes.content}>
            <div className={classes.toolbar} />
            <Switch>
              <Route path="/login" render={()=>(<Login container={this} />)} />
              <AuthRequired path="/dashboard" component={Dashboard} />
              <Route path="/clients" >
                <Switch>
                  <AuthRequired path="/clients/all" component={ClientAll} />
                  <AuthRequired path="/clients/new" component={ClientNew} />
                  <AuthRequired path="/clients/edit/:client_id" component={ClientAll} />
                  <Redirect from="/clients" to="/clients/all" />
                </Switch>
              </Route>
              <Route path="/devices" >
              <Switch>
                <AuthRequired key="online" path="/devices/online" title="Online devices" state_filter="online" component={DeviceAll} />
                <AuthRequired path="/devices/all" key="all" component={DeviceAll} />
                <AuthRequired path="/devices/new" key="all" component={DeviceNew} />
                <Redirect from="/devices" to="/devices/online" />
              </Switch>
            </Route>
            {admin_content}
            <Route path="/settings">
              <Switch>
                <AuthRequired path="/settings/account" component={SettingAccount} />
                <AuthRequired path="/settings/security" component={SettingSecurity} />
                <Redirect from="/settings" to="/settings/account" />
              </Switch>
            </Route>
            <Redirect from="/" to="/dashboard" />
            </Switch>
          </main>
        </div>
      </Router>
    );
  }
}

export default withStyles(styles, {
  withTheme: true
})(App);



// WEBPACK FOOTER //
// ./src/App.js